import type { ModelsItemType } from "../models";
import { apiInstance } from "../utils/_apiInstance";

interface Response {
  success: boolean;
  result: ModelsItemType;
}

export const getModelById = async (id: string) => {
  const response = await apiInstance.get<Response>(
    `pesquisa/modelos?_id=${id}`
  );
  return response.data.result;
};
